import MainMenu from "./main-menu/Main-menu";
import clsx from "clsx";
import { menu } from "./main-menu/menu";
import styles from "./main.module.scss";
import { History, News } from "../../types/types";
import Empty from "../@ui/empty/Empty";
import MainNews from "./main-news/Main-news";
import MainHistory from "./main-history/Main-history";
import { useState, useEffect } from "react";

interface Props {
  histories: History[] | null;
  news: News[] | null;
}

const Main = ({ histories, news }: Props) => {
  const [showHistory, setShowHistory] = useState(false);
  const [viewedHistories, setViewedHistories] = useState<string[]>([]);

  // Загружаем просмотренные истории из localStorage при загрузке компонента
  useEffect(() => {
    const savedViews = localStorage.getItem("viewedHistories");
    if (savedViews) {
      setViewedHistories(JSON.parse(savedViews));
    }
  }, []);

  // Функция для открытия истории
  const handleOpenHistory = () => {
    setShowHistory(true);

    // Сохраняем в localStorage, что история просмотрена
    const historyId = "fcore_history_1"; // Уникальный ID для истории
    if (!viewedHistories.includes(historyId)) {
      const updatedViews = [...viewedHistories, historyId];
      setViewedHistories(updatedViews);
      localStorage.setItem("viewedHistories", JSON.stringify(updatedViews));
    }
  };

  // Функция для закрытия истории
  const handleCloseHistory = () => {
    setShowHistory(false);
  };

  // Проверяем, просмотрена ли история
  const isHistoryViewed = viewedHistories.includes("fcore_history_1");

  return (
    <>
      {showHistory && (
        <MainHistory
          duration={7000}
          onClose={handleCloseHistory}
          autoClose={true}
        />
      )}
      <main className={styles.main}>
        <img src="/logo.svg" alt="logo" />
        <section className={styles.main__header}>
          <div className={styles.subtitle__wrap}>
            <div className={styles.header__blur} />
            <p className={styles.header__subtitle}>Веб-платформы</p>
            <p className={styles.header__subtitle}>Приложения</p>
            <div className={clsx(styles.header__blur, styles.right)} />
          </div>

          <div className={styles.header__info}>
            <h1>Digital агентство</h1>
            <p>
              IT решения на <span>любой</span> вкус
            </p>
          </div>
        </section>
        <section className={styles.main__menu}>
          {menu.map((item) => (
            <MainMenu key={item.name} {...item} />
          ))}
        </section>
        <h2>Наш блог</h2>
        <section className={styles.main__histories}>
          <div className={styles.histories}>
            <div
              className={`${styles.history} ${
                !isHistoryViewed ? styles.history__unviewed : ""
              }`}
              onClick={handleOpenHistory}
            >
              <img
                src="./fcore_logo.png"
                alt=""
                className={styles.history__img}
              />
              {!isHistoryViewed && (
                <div className={styles.history__indicator} />
              )}
            </div>
          </div>
        </section>
        <div className={styles.down__wrap}>
          <p>Новости</p>
          <img src="/arrow_down.svg" alt="" />
        </div>
        <section className={styles.main__blog}>
          {news?.length === 0 ? (
            <Empty type="Новости" />
          ) : (
            news?.map((item) => <MainNews key={item.id} {...item} />)
          )}
        </section>
      </main>
    </>
  );
};
export default Main;
